export default __webpack_public_path__ + "static/media/image_11.f57d107e.jpg";